import { Injectable, NgZone, Component, Injector } from '@angular/core';
import moment from 'moment';
import { minBookingDateFromTemple } from '@otas/shared/booking-day-policy';
import { istFormat } from '@otas/utils/custom-components/panchang-calendar/ist';
import { Router } from '@angular/router';
import { ToasterService } from '../services/toaster.service';

import { DataResolverService } from '../added-pooja-list/data-resolver.service';
import { WindowRefService } from '../added-pooja-list/WindowRef.service';
import { v4 as uuid } from 'uuid';
import { PaymentConstants } from '../payment.constants';
import * as _ from 'underscore';
import { finalize } from 'rxjs/operators';
import { AFTER_LOGIN_ACTION } from '../model/login-enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject } from 'rxjs';
import { LoaderService } from './loader.service';
import { LoginModalService } from '../user-configuration/login-modal/login-modal.service';
import { AuthenticationService } from '../shared/auth/authentication.service';
import { LoginModalComponent } from '../user-configuration/login-modal/login-modal.component';
import { PaymentModalComponent } from '../payment-modal/payment-modal.component';
import { HttpClient } from '@angular/common/http';
import { GenericResponse } from '../model/genericResponse';
import { Api } from '../shared/util/api';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  removedPoojas = new Subject();
  theArray = null;
  convenienceCharge = 0;
  constructor(
    private router: Router,
    private toastr: ToasterService,
    private http: HttpClient,
    private loaderService: LoaderService,
    private winRef: WindowRefService, private dataResolverService: DataResolverService,
    private injector: Injector,
    public dialog: NgbModal,
    private ngZone: NgZone) {

    //  const inj= Injector.create({
    //     providers: [
    //       { provide: 'loginModalService', useExisting: 'LoginModalService', deps: [NgbModal] },
    //       {
    //         provide: 'authenticationService', useExisting: 'AuthenticationService', deps: [AngularFireAuth,
    //           LoginService,
    //           ToasterService,
    //           Router,
    //           NgZone,
    //           WindowRefService,
    //           ActivatedRoute,
    //           PaymentService]
    //       },


    //     ],
    //     parent: injector
    //   })


  }

  getCartKey(): string {
    const tuid = localStorage.getItem('tuid');
    return tuid ? `BookingDetails_${tuid}` : 'BookingDetails';
  }
  // _payment() {
  //   this.loaderService.secondaryLoader.next(true);

  //   const currTemple = JSON.parse(localStorage.getItem('temple'))[0];
  //   const time = moment(currTemple.onlineDayEnd, ['h:m a', 'H:m']).toDate()

  //   const maxTime = moment((window as any).currentdate).set({
  //     hour: time.getHours(),
  //     minute: time.getMinutes(), second: time.getSeconds(), millisecond: time.getMilliseconds()
  //   });
  //   const modeDate = moment().isSameOrBefore(maxTime) ? true : false;


  //   const currentUser = JSON.parse(localStorage.getItem('currentUser'));
  //   const bookingDetails = JSON.parse(localStorage.getItem(this.getCartKey()));
  //   if (!currentUser.phoneNo || (!!currentUser.phoneNo && !['true', true].includes(currentUser.phoneVerification))) {
  //     const loginModalService = this.injector.get(LoginModalService);
  //     const authenticationService = this.injector.get(AuthenticationService);
  //     authenticationService.afterLogin.next(AFTER_LOGIN_ACTION.PAYMENT);

  //     loginModalService.openLoginModal(LoginModalComponent as Component, {
  //       activeAction: AFTER_LOGIN_ACTION.MOBILE_OTP, mobileNumber: currentUser.phoneNo
  //     });
  //     this.loaderService.secondaryLoader.next(false);
  //     return;
  //   }
  //   if (!modeDate) {
  //     const tomorrow = moment((window as any).currentdate).add(1, 'days');
  //     const tmrw = moment(tomorrow, 'DD/MM/YYYY').toDate();
  //     console.log('tmrw > ', tmrw);
  //     const data = _.filter(bookingDetails, d => d.date === DateService.dateToFormattedString(tmrw, 'DD/MM/YYYY'));
  //     if (!!data.length) {
  //       data.forEach(element => {
  //         console.log('tmrw >> ', element.date);
  //         bookingDetails.splice(bookingDetails.indexOf(element), 1);
  //       });
  //       this.toastr.warning('Time exceeded to book some poojas in your cart', 'REMOVE POOJA');
  //       let paymentTotal = 0;
  //       bookingDetails.forEach(element => {
  //         paymentTotal = paymentTotal + element.rate * element.quantity;
  //       });
  //       localStorage.removeItem(this.getCartKey());
  //       localStorage.setItem(this.getCartKey(), JSON.stringify(bookingDetails));
  //     }
  //     this.removedPoojas.next(bookingDetails);


  //   }


  //   //    day.blocked=true;
  //   //  }
  //   this.addedPoojaListService.invoiceAutoIncrement().subscribe(response => {
  //     this.loaderService.secondaryLoader.next(true);
  //     let invoiceNo = response.result;
  //     const date: any = (window as any).currentdate;
  //     const detailsArray = [];
  //     bookingDetails.forEach(element => {
  //       let poojaDate = null;
  //       let poojaDateList = null;
  //       let quantity = 1;

  //       if (!element.date.includes('+')) {
  //         poojaDate = moment(element.date, 'DD/MM/YYYY').toDate();
  //       } else {
  //         poojaDateList = element.selectedDates.map(e => moment(e, 'DD/MM/YYYY').toDate() as any * 1);
  //         quantity = element.selectedDates.length;
  //       }
  //       if (!!currentUser) {
  //         if (!!currentUser.address) {
  //           let el = '';
  //           currentUser.address.split(',').forEach(elem => {
  //             if (elem !== 'null') {
  //               if (!el.length) {
  //                 el = elem;
  //               } else {
  //                 el = el + ',' + elem;
  //               }
  //             }
  //           });
  //           const a = el.replace(/(^[,\s]+)|([,\s]+$)/g, '');
  //           element.address = a;
  //         }
  //         if (!!currentUser.phoneNo) {
  //           element.phone = currentUser.phoneNo;
  //         }
  //       }

  //       if (!!poojaDateList) {
  //         poojaDateList.forEach((part, index) => {
  //           this.theArray[index] = moment(part).format('DD-MM-YYYY').toString();
  //         });
  //         poojaDateList = this.theArray;
  //       }


  //       detailsArray.push({
  //         productId: element.productId, deityId: element.deityId, quantity,
  //         rate: element.rate, amount: element.rate * quantity, devoteeName: element.devorteeName,
  //         devoteeStar: element.star, address: element.address, gothram: null, rasi: null,
  //         poojaDate: poojaDate ? (moment(poojaDate * 1).format('DD-MM-YYYY').toString()) : null,
  //         phone: element.phone, email: null, poojaDateList,
  //         personalId: null, unitId: null, storeId: null, isIssued: null, isStockUpdated: null,
  //         property: null, accountHeadId: null, postage: false, note: null, dob: null,
  //         poojaTime: null, description: null
  //       });
  //     });
  //     let total = 0;
  //     detailsArray.forEach(element => {
  //       total = total + element.amount;
  //     });
  //     const uid = uuid();
  //     const data = {
  //       invoiceNo, transactionType: 'ONLINE', chequeNo: null, bankAccountId: null,
  //       advancedAmount: total, invoiceDate: date * 1, details: detailsArray,
  //       isChequeCleared: null, isManualEntry: false, isFamily: null, parentFamilyId: null,
  //       note: null, bookingRefId: uid, familyName: null, familyPhoneNo: null,
  //       paymentAmount: total
  //     };

  //     this.addedPoojaListService.bookPooja(data)// currentUser
  //       .pipe(finalize(() => {
  //         this.loaderService.secondaryLoader.next(false);

  //       }))
  //       .subscribe(res => {
  //         if (!!response) {
  //         }
  //         if (res.status === 'SUCCESS') {
  //           this.addedPoojaListService.invoiceAutoIncrement()
  //             .subscribe(resp => {
  //               invoiceNo = resp.result;
  //             });
  //           localStorage.removeItem(this.getCartKey());
  //           this.loaderService.secondaryLoader.next(true);
  //           this.openSuccessPage(res.result);
  //           this.razorPay(data, res.result);
  //           const familyMembers = JSON.parse(localStorage.getItem('familyMembers'));
  //           if (!!familyMembers) {
  //             familyMembers.forEach(element => {
  //               element.userId = currentUser.userId;
  //             });
  //             this.addedPoojaListService.addFamilyMember(familyMembers)
  //               .subscribe(() => {
  //                 localStorage.removeItem('familyMembers');
  //               });
  //           }
  //         }
  //       });
  //   });
  // }
  openSuccessPage(result) {
    localStorage.setItem('success', JSON.stringify(result));
    this.dataResolverService.paymentResponse = result;
    this.dataResolverService.homeRoute = 'pooja-booking';
    localStorage.setItem('backUrl', 'pooja-booking');
    // this.ngZone.run(() => this.router.navigate(['success']).then());
  }

  razorPay(data: any, resp: any) {
    const temple = JSON.parse(localStorage.getItem('temple'))[0];
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.loaderService.secondaryLoader.next(true);
    const options: any = {
      key: resp.razorPayOrder.razorpayMerchantId,
      amount: resp.razorPayOrder.amount, // data.paymentAmount * 100
      currency: PaymentConstants.CURRENCY,
      name: temple.nameShort,
      // description: PaymentConstants.DESCRIPTION,
      description: resp.razorPayOrder.razorpayOrderId,
      image: PaymentConstants.ICON,
      order_id: resp.razorPayOrder.razorpayOrderId,
      account_id: resp.razorPayOrder.razorpayAccountId,
      modal: {
        escape: false
      },
      prefill: {
        name: (!!currentUser.firstName ? currentUser.firstName : '') + ' '
          + (!!currentUser.lastName ? currentUser.lastName : ''),
        contact: currentUser.phoneNo,
        email: currentUser.email
      },
      notes: {
        address: (!!currentUser.address ? currentUser.address : ''),
        temple: temple.nameShort
      },
      theme: {
        color: PaymentConstants.COLOR
      }
    };
    options.handler = ((response) => {
      this.loaderService.secondaryLoader.next(false);
      response.bookingId = resp.bookingId;
      response.invoiceId = resp.list[0].invoiceId;
      response.amount = data.paymentAmount;
      // this.handlePayment(response);
      localStorage.setItem('paymentresponse', JSON.stringify(response));
      // this.router.navigate(['success']);
      this.ngZone.run(() => this.router.navigate(['success']).then());
    });
    options.modal.ondismiss = (() => {
      this.loaderService.secondaryLoader.next(false);
      localStorage.setItem('backUrl', 'pooja-booking');

      localStorage.setItem('failedData', JSON.stringify(data));
      localStorage.setItem('viewData', JSON.stringify(resp));
      this.ngZone.run(() => this.router.navigate(['pooja-booking/transaction-failure']).then());
    });
    const rzp = new this.winRef.nativeWindow.Razorpay(options);
    rzp.open();
  }

  // cashFree(_orderToken) {
  //   const options: any = {
  //     components: [
  //       'upi-intent',
  //       'upi-collect',
  //       'card',
  //       'netbanking',
  //       'app'
  //     ],
  //     orderToken: _orderToken,
  //     onSuccess(_data) {
  //       console.log('payment response : ', _data);
  //       localStorage.removeItem('orderToken');
  //       localStorage.setItem('paymentresponse', JSON.stringify(_data));
  //       this.router.navigate(['success']);
  //       this.ngZone.run(() => this.router.navigate(['success']).then());
  //     },
  //     onFailure(_data) {
  //       localStorage.setItem('backUrl', 'pooja-booking');
  //       localStorage.setItem('failedData', JSON.stringify(_data));
  //       localStorage.setItem('viewData', JSON.stringify(_data));
  //       this.ngZone.run(() => this.router.navigate(['transaction-failure']).then());
  //     },
  //     style: {
  //       backgroundColor: '#ffffff',
  //       color: '#e67207',
  //       fontFamily: 'Lato',
  //       fontSize: '14px',
  //       errorColor: '#ff0000',
  //       theme: 'light', // (or dark)
  //     }
  //   };
  //   const cf = new this.winRef.nativeWindow.Cashfree();
  //   const paymentElement = document.getElementById('payment-form');
  //   cf.initialiseDropin(paymentElement, options);
  // }

  payment() {
    const bookingDetails = JSON.parse(localStorage.getItem(this.getCartKey()));
    this.loaderService.secondaryLoader.next(true);
    const currTemple = JSON.parse(localStorage.getItem('temple'))[0];
    console.log('currTemple : ', currTemple);
    this.convenienceCharge = currTemple.convenienceCharge;
    // Booking-day policy (temple.ONLINE_DAY_END via the shared util): the
    // final checkout revalidation — anything dated before the effective
    // minimum (null = PAST, nothing expires) is stripped below.
    const minBookable = minBookingDateFromTemple();
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (!currentUser.phoneNo || (!!currentUser.phoneNo && !['true', true].includes(currentUser.phoneVerification))) {
      const loginModalService = this.injector.get(LoginModalService);
      const authenticationService = this.injector.get(AuthenticationService);
      authenticationService.afterLogin.next(AFTER_LOGIN_ACTION.PAYMENT);

      loginModalService.openLoginModal(LoginModalComponent as Component, {
        activeAction: AFTER_LOGIN_ACTION.MOBILE_OTP, mobileNumber: currentUser.phoneNo
      });
      this.loaderService.secondaryLoader.next(false);
      return;
    }

    if (minBookable) {
      // Strip every cart item dated before the policy minimum (generalizes
      // the old "remove tomorrow's poojas after the cutoff" rule). Compared
      // as IST calendar-day labels so the browser's zone can't shift it.
      const minLabel = istFormat(minBookable, 'YYYY-MM-DD');
      const data = _.filter(bookingDetails, (d: any) => {
        const itemDate = moment(d.date, ['DD/MM/YYYY', 'YYYY-MM-DD']);
        return itemDate.isValid() && itemDate.format('YYYY-MM-DD') < minLabel;
      });
      if (!!data.length) {
        data.forEach(element => {
          bookingDetails.splice(bookingDetails.indexOf(element), 1);
        });
        this.toastr.warning('Time exceeded to book some poojas in your cart', 'REMOVE POOJA');
        let paymentTotal = 0;
        bookingDetails.forEach(element => {
          paymentTotal = paymentTotal + element.rate * element.quantity;
        });
        localStorage.removeItem(this.getCartKey());
        localStorage.setItem(this.getCartKey(), JSON.stringify(bookingDetails));
      }
      // this.removedPoojas.next(bookingDetails);
    }
    console.log('bookingDetails', bookingDetails);
    this.makePayment(bookingDetails);
  }

  makePayment(bookingDetails: any[]): string {
    // this.addedPoojaListService.invoiceAutoIncrement().subscribe(response => {
    this.loaderService.secondaryLoader.next(true);
    // let invoiceNo = '';
    const date: any = (window as any).currentdate;
    const detailsArray = [];
    bookingDetails.forEach(element => {
      let poojaDate = null;
      let poojaDateList = null;
      // theArray: any[] = [];
      let quantity = 1;

      if (!element.date.includes('+')) {
        poojaDate = moment(element.date, 'DD/MM/YYYY').toDate();
      } else {
        poojaDateList = element.selectedDates.map(e => moment(moment(e, 'DD/MM/YYYY').toDate() as any * 1).format('DD-MM-YYYY').toString());
        quantity = element.selectedDates.length;
      }
      // if (!!currentUser) {
      //   if (!!currentUser.address) {
      //     let el = '';
      //     currentUser.address.split(',').forEach(elem => {
      //       if (elem !== 'null') {
      //         if (!el.length) {
      //           el = elem;
      //         } else {
      //           el = el + ',' + elem;
      //         }
      //       }
      //     });
      //     const a = el.replace(/(^[,\s]+)|([,\s]+$)/g, '');
      //     element.address = a;
      //   }
      //   if (!!currentUser.phoneNo) {
      //     element.phone = currentUser.phoneNo;
      //   }
      // }

      // if (!!poojaDateList) {
      //   poojaDateList.forEach((part, index) => {
      //     this.theArray[index] = moment(part).format('DD-MM-YYYY').toString();
      //   });
      //   poojaDateList = this.theArray;
      //   this.theArray = null;
      // }
      detailsArray.push({
        productId: element.productId, templeDeityId: element.templeDeityId, quantity,
        amount: element.rate * quantity, devoteeName: element.devorteeName,
        devoteeStar: element.star,
        poojaDate: poojaDate ? [(moment(poojaDate * 1).format('DD-MM-YYYY').toString())] : poojaDateList,
        poojaTime: null, description: null
      });
    });
    let total = 0;
    detailsArray.forEach(element => {
      console.log('element.amount : ', element.amount);
      total = total + element.amount;
    });
    const uid = uuid();
    console.log('total : ', total);
    console.log('this.convenienceCharge : ', this.convenienceCharge);
    this.convenienceCharge = this.getServiceCharge(total, this.convenienceCharge);
    // this.upperRoundOff(total * ((this.convenienceCharge || 0) / 100));
    console.log('this.convenienceCharge> : ', this.convenienceCharge);
    const data = {
      bookingRefId: uid, paymentAmount: total, convenienceCharge: this.convenienceCharge, paymentMethod: null,
      paymentKey: null, paymentValue: null, poojaOrderRequestDetail: detailsArray
    };

    this.bookPooja(data)
      .pipe(finalize(() => {
        this.loaderService.secondaryLoader.next(false);

      }))
      .subscribe(res => {
        if (res.status === 'SUCCESS') {
          localStorage.removeItem(this.getCartKey());
          this.loaderService.secondaryLoader.next(true);
          this.openSuccessPage(res.result);
          const orderToken = res.result.orderToken;
          localStorage.setItem('orderToken', orderToken);
          this.openPaymentDialog();
          // const familyMembers = JSON.parse(localStorage.getItem('familyMembers'));
          // if (!!familyMembers) {
          //   familyMembers.forEach(element => {
          //     element.userId = currentUser.userId;
          //   });
          //   this.poojaModalService.addFamilyMember(familyMembers)
          //     .subscribe(() => {
          //       localStorage.removeItem('familyMembers');
          //     });
          // }
        }
      });
    return '';
    // });
  }

  // roundToTwo(num) {
  //   return Math.round((num + Number.EPSILON) * 100) / 100;
  // }
  getServiceCharge(total, convenience): number {
    const charge = this.upperRoundOff((total * (convenience || 0)) / 100);
    if (charge === 0) {
      return 0;
    }
    return charge < 1 ? 1 : charge;
  }
  upperRoundOff(num) {
    return Math.ceil(num * 100) / 100;
  }

  openPaymentDialog() {
    const dialogRef = this.dialog.open(PaymentModalComponent, {
      size: 'xl',              // 'sm', 'lg', 'xl'
      centered: true,          // vertically centered
      backdrop: 'static',      // prevent closing on outside click
      keyboard: false,          // prevent closing on Esc key
      windowClass: "shivam-payment-dialog"
    });
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`);
    // });
  }

  bookPooja(data): Observable<GenericResponse<any>> {
    return this.http.post<GenericResponse<any>>(Api.order, data);
  }

}
